module.exports = __webpack_public_path__ + "img/1280px-Equifax_Logo.svg.affdfd3b.png";